import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../buttons_refactor/Button';
import AboutTechsicoEnterprise from '../../images/about/about.png';

const About = () => (
  <div
    id="about"
    className="flex flex-col mx-5.5 my-12 md:flex-row md:mx-20 lg:mx-12 lg:my-20 2xl:my-18 2xl:mx-24 3xl:mx-33 3xl:my-28"
  >
    <div className="flex items-center md:order-2 2xl:ml-12">
      <img
        src={AboutTechsicoEnterprise}
        alt="About TECHSICO Enterprise"
        className="rounded-2xl w-full md:w-58 lg:w-79 2xl:w-154 3xl:w-154"
      />
    </div>
    <div className="flex-1 md:w-87 md:mr-5.5 md:order-1 lg:w-113 lg:mr-12 lg:ml-15 2xl:w-142 2xl:my-6 3xl:w-216 3xl:ml-11">
      <h2 className="mb-4 mt-4 font-montserrat font-bold text-2xl leading-1.2em lg:text-4xl lg:leading-1.2em 2xl:text-5xl 2xl:leading-1.2em 3xl:text-6.3xl">
        About
      </h2>
      <p className="mt-4 mb-6 font-montserrat leading-1.55em text-techsicoGray-400 lg:text-lg lg:mb-8 2xl:text-2xl 2xl:mb-12 2xl:leading-1.55em 3xl:text-3.5xl">
        Techsico Enterprise is committed to delivering high-quality solutions
        that satisfy our customers. Our growth and continual training ensure
        that we continue to provide advanced technological solutions to as many
        people as we can.
      </p>
      <Link to="/about" tabIndex="-1">
        <Button>Read More</Button>
      </Link>
    </div>
  </div>
);

export default About;
